import { useState } from "react";
import { useStore, formatCOP } from "../lib/store";
import { SERVICE_CATEGORIES } from "../data/siteData";
import { ArrowUpRight } from "lucide-react";

export const Services = ({ onReserve }) => {
  const { services } = useStore();
  const [active, setActive] = useState(SERVICE_CATEGORIES[0].id);

  const filtered = services.filter((s) => s.category === active);

  return (
    <section id="servicios" className="section-padding bg-white" data-testid="services-section">
      <div className="container-aura">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="text-xs tracking-luxe uppercase text-gold mb-4">Catálogo</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-ink leading-tight mb-5">
            Nuestros <span className="italic text-gold">tratamientos</span>
          </h2>
          <div className="gold-divider mx-auto mb-6"></div>
          <p className="text-base md:text-lg text-ink-soft font-light">
            Descubre una selección curada de rituales y tratamientos diseñados para realzar tu belleza natural.
          </p>
        </div>

        {/* Category tabs */}
        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-12" data-testid="service-tabs">
          {SERVICE_CATEGORIES.map((cat) => {
            const isActive = active === cat.id;
            return (
              <button
                key={cat.id}
                onClick={() => setActive(cat.id)}
                data-testid={`tab-${cat.id}`}
                className={`px-5 md:px-7 py-3 rounded-full text-xs tracking-luxe uppercase font-medium transition-all duration-300 ${
                  isActive
                    ? "bg-ink text-white shadow-lg"
                    : "bg-beige-50 text-ink-soft hover:bg-beige-100 border border-beige-200"
                }`}
              >
                <span className="hidden md:inline">{cat.label}</span>
                <span className="md:hidden">{cat.short}</span>
              </button>
            );
          })}
        </div>

        {/* Service cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {filtered.map((s) => (
            <article
              key={s.id}
              data-testid={`service-card-${s.id}`}
              className="group relative bg-beige-50 rounded-3xl overflow-hidden border border-beige-200 hover:border-gold transition-all duration-500 hover:shadow-[0_20px_40px_-12px_rgba(0,0,0,0.1)]"
            >
              <div className="aspect-[4/3] overflow-hidden bg-beige-100">
                <img
                  src={s.image}
                  alt={s.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-6 md:p-7">
                <h3 className="font-serif text-2xl text-ink mb-2 leading-tight">{s.name}</h3>
                <p className="text-sm text-ink-soft leading-relaxed mb-5 font-light min-h-[60px]">
                  {s.description}
                </p>

                <div className="flex items-end justify-between pt-4 border-t border-beige-200">
                  <div>
                    <div className="text-[10px] tracking-luxe uppercase text-ink-soft">Desde</div>
                    <div className="font-serif text-2xl text-gold mt-0.5">{formatCOP(s.price)}</div>
                  </div>
                  <button
                    onClick={() => onReserve(s)}
                    data-testid={`reserve-${s.id}`}
                    className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full bg-ink text-white text-xs tracking-luxe uppercase transition-all duration-300 hover:bg-gold group/btn"
                  >
                    Reservar
                    <ArrowUpRight size={14} className="transition-transform group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5" />
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="text-center text-ink-soft py-12">Aún no hay servicios en esta categoría.</div>
        )}
      </div>
    </section>
  );
};
